<template>
  <div class="button-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ButtonGroup"
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.button-group {
  padding: toRem(4);
  display: grid;
  background: rgba(68, 72, 109, 0.07);
  border-radius: 8px;
  grid-auto-flow: column;
  gap: toRem(4);

  ::v-deep(.p-button) {
    &.selected {
      background: $bgBlocks;
      font-weight: 600;
    }

    color: $textSecondaryColor;
    background: none;

    @media (max-width: $tabletBreakpoint) {
      font-size: toRem(14);
    }
  }
}
</style>
